import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import EventButton from '../../../modules/analytics/components/EventButton/EventButton';
import { FloatPropType } from '../../../services/proptypes';
export default function CarouselArrow(_ref) {
  var orientation = _ref.orientation,
    onToggle = _ref.onToggle,
    currentIndex = _ref.currentIndex;
  return /*#__PURE__*/React.createElement(EventButton, {
    "aria-label": "See ".concat(orientation === 'right' ? 'next' : 'previous', " image"),
    event: {
      category: 'Image-Collection',
      action: 'Click',
      label: orientation
    },
    secondary: true,
    circular: true,
    icon: "angle ".concat(orientation),
    onClick: function onClick() {
      return onToggle(currentIndex + (orientation === 'right' ? 1 : -1));
    },
    className: "ic-carousel-arrow",
    style: _objectSpread({}, orientation === 'right' ? {
      right: -15
    } : {
      left: -15
    })
  });
}